<template>
  <div class="home">
<NavbarSesion/>
<bannerHero/>
<FooterHero/>

  </div>
</template>

<script>
import NavbarSesion from '@/components/NavbarSesion.vue';
import bannerHero from '@/components/Planes/bannerHero.vue';
import FooterHero from '@/components/FooterHero.vue';
export default {
  name: 'HomeView',
  components: {
NavbarSesion,
bannerHero,
FooterHero
  }
}
</script>
